import type { MediaKind } from '../hooks'

export type MentionItem = {
  kind: MediaKind
  mediaId: string
  /**
   * 1-based index within the kind's list. Derived from current multiRefResource state
   * at render time, not stored.
   */
  index: number
}

/**
 * Fixed label format sent to backend. The UI may display localized labels
 * but serialization is always English to keep backend prompt parsing stable.
 */
export const KIND_TOKEN: Record<MediaKind, string> = {
  image: 'image',
  video: 'video',
  audio: 'audio',
}

export function kindToken(kind: MediaKind, index: number): string {
  return `@${KIND_TOKEN[kind]}${index}`
}

/**
 * Regex capturing `@image1`, `@video2`, `@audio3`, etc.
 * Group 1: kind; Group 2: 1-based index.
 *
 * Digits are greedy: `@image12` always parses as index 12, never as
 * `@image1` + literal `2`. No escape syntax for writing a literal digit
 * right after a mention — users must insert whitespace (e.g. `@image1 2`).
 */
export const MENTION_PATTERN = /@(image|video|audio)(\d+)/gi
